import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	klik(event) {
		if (event.target.classList[0] == "calendar-session-title") {
			event.stopPropagation()
			return
		}

		const dayDiv = event.target.closest(".has-events")
		if (dayDiv) {
			const dayEvent = dayDiv.querySelector(".calendar-txt-content")
			if (dayEvent.offsetParent) {
				event.preventDefault()
				event.stopPropagation()
			}
		}
	}
}
